import React, { useEffect } from 'react'
import FaqAccordion from './FaqAccordion';
import SEO from '../components/SEO';

const FAQ = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className='xyz1'>
      <SEO
        title="Frequently Asked Questions | Lavanya Infotech"
        description="Find answers to common questions about Lavanya Infotech's services, pricing, technologies, and support. Learn more about how we can help your business grow."
      />

      <h1 className="title font-poppins text-4xl sm:text-5xl xl:pt-10 text-center font-bold">
        FAQ
        <div className="aurora text-3xl">
          <div className="aurora__item"></div>
          <div className="aurora__item"></div>
          <div className="aurora__item"></div>
          <div className="aurora__item"></div>
        </div>
      </h1>

      <div className="text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto pb-10">
        <h1 className="font-poppins text-2xl sm:text-3xl md:text-4xl font-bold text-white pt-16">
          <span style={{ color: '#d4e09b' }} >Frequently</span> <span style={{ color: '#f6f4d2' }} >Asked</span> <span style={{ color: '#cbdfbd' }} >Questions</span>
        </h1>
        <p className="text-sm sm:text-base md:text-lg text-gray-300 mt-4">
          Read the latest property how-to guides, and information and tips for buying, selling, investing and renting.
        </p>
      </div>


      <FaqAccordion />

      <div className="w-full pt-5 pb-5">
        <hr className="border-t border-white opacity-200" />
      </div>


    </div>
  )
}

export default FAQ